'use client';

import { languageContext } from '@repo/features/languageContext';
import { AppLanguageCode } from '@repo/entities/AppLanguage';
import { ReactNode, useState } from 'react';

// Seeded from the cookie the root layout read, so the first paint is localized.
export const LanguageProvider = ({
  languageCode: initialLanguageCode,
  children,
}: {
  languageCode: AppLanguageCode;
  children: ReactNode;
}) => {
  const [languageCode, setLanguageCode] =
    useState<AppLanguageCode>(initialLanguageCode);

  return (
    <languageContext.Provider value={{ languageCode, setLanguageCode }}>
      {children}
    </languageContext.Provider>
  );
};
